import { render, staticRenderFns } from "./EditSubGroup.vue?vue&type=template&id=468a2d5e&scoped=true&"
import script from "./EditSubGroup.vue?vue&type=script&lang=js&"
export * from "./EditSubGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditSubGroup.vue?vue&type=style&index=0&id=468a2d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a2d5e",
  null
  
)

export default component.exports